export default (type) => {
  return {
    'event': 'pwd_otp',
    'funnel_name': 'MYB',
    'sub_funnel_name': 'recovery',
    'recovery_type': type,
  };
};